import React from "react";
import PropTypes from "prop-types";
import { getAsset } from "../../../utilities/assets.utils";
import { Button } from "../../../components/Button";

/**
 * @param {SuccessMessage.propTypes} props
 */
export const SuccessMessage = (props) => {
	if (!props.updatedPageURL) return null;

	return (
		<div className="bg-plugin-1-light rounded-sm px-12 sm:px-16 p-8 mb-6">
			<div className="flex flex-col items-center">
				<img
					src={getAsset("success.png")}
					alt=""
					className="w-16 mb-2"
				/>
				<div className="text-xl font-semibold mt-2">Awesome!</div>
				<div className="mt-3 mb-4 text-center leading-6">
					{props.hasSavedConfig
						? "Your changes have been saved."
						: props.isNewPage
						? "We have created a page with HootBoard for you!"
						: "We have updated the HootBoard page for you!"}
				</div>
				<Button
					label="Go to the page!"
					href={props.updatedPageURL}
					color="plugin-1"
				/>
			</div>
		</div>
	);
};

SuccessMessage.propTypes = {
	isNewPage: PropTypes.bool,
	hasSavedConfig: PropTypes.bool,
	updatedPageURL: PropTypes.string,
};
